import React from 'react'
import { Field } from 'redux-form'

const RadioGroup = props => (
  <div
    className={`u-package-forms-radio-group ${
      props.displayFlex ? 'u-flex-container' : ''
    }`}
  >
    {props.options.map((option, i) => {
      return (
        <label
          key={option.label + i}
          className="u-package-forms-radio-group-label"
        >
          <Field
            name={props.name}
            component={'input'}
            type="radio"
            value={option.value}
            className={`u-package-forms-radio-group-input ${
              props.isRadio ? 'radio' : ''
            }`}
          />
          {option.label}
        </label>
      )
    })}
  </div>
)

export default RadioGroup
